export default {
    screenTitle: {
        login: 'Đăng nhập',
        forgotPassword: 'Quên mật khẩu',
        resetPassword: 'Đặt lại mật khẩu',
        regNewAcc: 'Đăng ký tài khoản mới',
        error404: 'Lỗi 404 - Không tìm thấy trang',

        articleList: 'Danh sách bài viết',
        articleNew: 'Tạo bài viết mới',
        articleDetail: 'Chi tiết bài viết',

        giftCodeManage: 'Quản lý GiftCode',
        coinChargeManage: 'Quản lý nạp tiền',
        userListManager: 'Quản lý người dùng',
        billingPcLoggedInGameManage: 'Quản lý PC đăng nhập game',
        siteConfig: 'Cấu hình website',

        paymentHistory: 'Lịch sử giao dịch',
        transferToTLBB: 'Chuyển tiền vào Game Thiên Long Bát Bộ',
        chargeViaEBank: 'Nạp Tự Động qua chuyển khoản Ngân Hàng',
        chargeViaCard: 'Nạp tiền bằng thẻ cào',
        chargeViaCryptCoin: 'Nạp bằng Tiền mã hoá (Coin / Cryptocurrencies)',

        authPassword2: 'Xác nhận mật khẩu cấp 2',
        charGameFunc: 'Chức năng hỗ trợ nhân vật trong game',
    },

    labelText: {
        username: 'Tên đăng nhập',
        password: 'Mật khẩu',
        cur_password: 'Mật khẩu hiện tại',
        new_password: 'Mật khẩu mới',
        password_confirm: 'Xác nhận mật khẩu',
        password2: 'Mật khẩu cấp 2',
        password2_confirm: 'Xác nhận mật khẩu cấp 2',
        rememberMe: 'Ghi nhớ trạng thái đăng nhập',
        email: 'Email',
        agreeTos: 'Tôi đồng ý với các điều khoản sử dụng',

        created_at: 'Ngày tạo',
        updated_at: 'Ngày cập nhật',

        article_title: 'Tiêu đề',
        article_title_image: 'Hình ảnh tiêu đề',
        article_slug: 'Đường dẫn',
        article_content: 'Nội dung',

        giftcode_type_name: 'Loại GiftCode',
        giftcode_type_keygen: 'Mã phân loại',

        payment_username: 'Tài khoản nhận tiền',
        payment_coin: 'Bạc Web',
        payment_coin_promotion: 'Bạc KM',
        payment_point: 'Bạc Game',
        payment_bank_owner: 'Chủ tài khoản',
        payment_bank_type: 'Loại tài khoản',
        payment_content: 'Nội dung giao dịch',
        payment_status: 'Trạng thái',
        payment_type: 'Loại giao dịch',
        payment_transaction_info: 'Thông tin giao dịch',

        coin_charge_admin_add_executor: 'Người thực hiện',

        user_name: 'Tên tài khoản',
        user_email: 'Email',
        user_tel: 'Số điện thoại',
        user_role: 'Vai trò',
        user_is_lock: 'Khóa',
        user_is_lock_true: 'Khóa',
        user_is_lock_false: 'Mở khóa',
        user_coin: 'Bạc Web',
        user_promotion_coin: 'Bạc KM',
        user_point: 'Bạc Game',
        user_question: 'Câu hỏi bảo mật',
        user_answer: 'Câu trả lời bảo mật',

        charge_card_serial: 'Số serial',
        charge_card_code: 'Mã thẻ',
        charge_card_type: 'Loại thẻ',
        charge_card_price: 'Mệnh giá thẻ',

        char_guid: 'ID Nhân vật',

        server_name: 'Tên Server',
    },

    message: {
        errorFetchUser: 'Lỗi khi lấy thông tin người dùng',
        fetchingUser: 'Đang lấy dữ liệu người dùng',
        fetchUserSuccess: 'Lấy dữ liệu đăng nhập thành công',
        confirmLogout: 'Bạn có chắc chắn muốn đăng xuất?',
        fetchError: 'Lỗi khi lấy dữ liệu',

        passwordNotMatch: 'Mật khẩu không khớp',
        passwordSame: 'Mật khẩu không được trùng',
        password2MustNotEqualPassword: 'Mật khẩu 2 không được trùng với mật khẩu đăng nhập',
        mustAgreeTos: 'Bạn phải đồng ý với các điều khoản sử dụng',
        regNewAccSuccess: 'Tài khoản [{accname}] đã đăng ký thành công',
        forgotPasswordUsePass2Success: 'Mật khẩu thay đổi thành công. Từ bây giờ bạn có thể đăng nhập với mật khẩu mới',
        forgotPasswordUseEmailRequestSent: 'Yêu cầu khôi phục đã được gửi đến email của bạn',
        passwordChangeSuccess: 'Đổi mật khẩu thành công',

        deleteConfirmContent: 'Bạn có chắc chắn muốn xóa?',
        deleteSuccess: 'Xóa thành công',

        createSuccess: 'Tạo mới thành công',
        saveSuccess: 'Lưu thành công',
        updateSuccess: 'Cập nhật thành công',
        success: 'Thành công',

        articleCreatedAtHelp: 'Có thể cài đặt giá trị tương lai để hiển thị phía trên các bài viết khác trong danh sách',

        giftCodeTypeKeygenHelp: '18 ký tự khai báo trong GiftCode.lua',

        userListClearConfirmContent: 'Bạn có chắc chắn muốn clear thông tin bảo mật hiện tại của người dùng?',
        userLockConfirm: 'Bạn có chắc chắn muốn khóa tài khoản này?',
        userUnlockConfirm: 'Bạn có chắc chắn muốn mở khóa tài khoản này?',
        userSetRoleConfirm: 'Bạn có chắc chắn muốn thay đổi vai trò của tài khoản này?',

        typePw2ToContinue: 'Nhập mật khẩu 2 để tiếp tục',

        paymentTransferToGameSuccess: 'Chuyển tiền thành công',
        paymentChargeCardSuccess: 'Gửi thẻ thành công, quá trình xử lí thẻ cào có thể mất vài phút',

        apiError: {
            unauthorized: 'Bạn chưa đăng nhập',
            unauthorized_pw2: 'Bạn cần nhập mật khẩu cấp 2',
            permission_denied: 'Truy cập bị cấm',
            wrong_data: 'Dữ liệu không hợp lệ',
            validation_error: 'Lỗi xác thực dữ liệu',
            max_login_failed_count: 'Số lần đăng nhập sai vượt quá giới hạn, vui lòng thử lại sau ít phút',
            wrong_login_info: 'Thông tin đăng nhập không đúng',
            timeout: 'Hết thời gian thực thi cho phép',
            unknown: 'Lỗi không xác định',
        },
        validError: {
            exists: 'Trường này đã tồn tại',
            not_exists: 'Trường này không tồn tại',
            locked: 'Trường này bị khóa',
            invalid: 'Dữ liệu không hợp lệ',
            wait_try_again: 'Vui lòng thử lại sau {seconds} giây',
        },
    },

    text: {
        home: 'Trang chủ',
        login: 'Đăng nhập',
        logout: 'Đăng xuất',
        register: 'Đăng ký',
        regNewAcc: 'Đăng ký tài khoản mới',
        or: 'Hoặc',
        changePassword: 'Đổi mật khẩu',
        action: 'Thao tác',
        save: 'Lưu',
        num: 'Số lượng',
        confirm: 'Xác nhận',
        reload: 'Tải lại',
        transfer: 'Chuyển',
        preview: 'Xem trước',
        max: 'Tối đa',
        chargeNow: 'Nạp ngay !!!',
        chargeEbankNow: 'Nạp bằng Chuyển Khoản ngay !!!',
        charge: 'Nạp',
        create: 'Tạo',
        search: 'Tìm kiếm',
        process: 'Xử lý',

        administrator: 'Quản trị viên',
        menuAdminArticle: 'Bài viết',
        menuAdminGiftCode: 'Quản lý GiftCode',
        menuAdminChargeCoin: 'Quản lý nạp tiền',
        menuAdminMangeUser: 'Quản lý người dùng',
        menuAdminPcLoginPermission: 'Quản lý phân quyền Login PC',
        menuAdminSiteConfig: 'Cấu hình trang web',
        account: 'Tài khoản',
        menuAccountManager: 'Quản lý tài khoản',
        chargeCoin: 'Nạp tiền',
        menuPaymentChargeUseCryptCoin: 'Nạp qua Coin / Tiền mã hoá',
        menuPaymentChargeUseBankTransfer: 'Nạp qua chuyển khoản Bank',
        menuPaymentChargeUseCard: 'Nạp bằng thẻ cào',
        menuPaymentHistory: 'Lịch sử giao dịch',
        tlbb: 'Thiên long bát bộ',
        menuTlbbTransferCoinToGame: 'Chuyển tiền vào Game',
        menuTlbbCharFunc: 'Chức năng hỗ trợ nhân vật',

        forgotPassword: 'Quên mật khẩu?',
        recoverForgotPassword: 'Khôi phục mật khẩu đã quên',
        forgotPasswordUsePass2: 'Khôi phục mật khẩu sử dụng mật khẩu 2',
        forgotPasswordUseEmail: 'Khôi phục mật khẩu sử dụng email',
        forgotPasswordUseSecurityQuestion: 'Khôi phục mật khẩu sử dụng câu hỏi bảo mật',
        forgotPasswordUseEmailRequest: 'Yêu cầu khôi phục',

        createNewGiftCodeType: 'Tạo Loại GiftCode mới',
        createNewGiftCode: 'Tạo GiftCode',

        userInfo: 'Thông tin tài khoản',
        updateUserInfo: 'Cập nhật thông tin tài khoản',
        notUpdated: 'Chưa cập nhật',
        updateUserPassword: 'Cập nhật mật khẩu đăng nhập',
        updateUserPassword2: 'Cập nhật mật khẩu cấp 2',
    },
}
